import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label, } from "recharts";
const COLORS = { withParticipante: "#009728", withOrganizacion: "#1976D2", sinRegistro: "#FAAD14" };

export default function MonthChart({ data, onMonthClick }) {

  const handleBarClick = (_entry, index) => {
    if (data[index] && data[index].month) {
      onMonthClick(data[index].month);
    }
  };

  return (
    <ResponsiveContainer width="100%" height={420}>
      <BarChart
        data={data}
        margin={{ top: 30, right: 30, left: 10, bottom: 120 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
        <XAxis
          dataKey="month"
          angle={-45}
          textAnchor="end"
          height={90}
          tick={{ fontSize: 12 }}
          interval={0}
        >
          <Label
            value="Meses"
            offset={-60}
            position="insideBottom"
            style={{ fill: "#444", fontSize: 14, textAnchor: "middle", }}
          />
        </XAxis>
        <YAxis>
          <Label
            value="Cantidad de Archivos"
            angle={-90}
            position="insideLeft"
            style={{ textAnchor: "middle", fill: "#444", fontSize: 14 }}
          />
        </YAxis>
        <Tooltip
  formatter={(value, name) => {
    const labels = {
      withParticipante: "Con Participante",
      withOrganizacion: "Con Organización",
      sinRegistro: "Sin Registro",
    };

    return [`${value}`, labels[name] || name];
  }}
  labelFormatter={(label) => `Mes: ${label}`}
  contentStyle={{
    backgroundColor: "#ffffff",
    border: "1px solid #dcdcdc",
    borderRadius: 8,
    padding: 8,
  }}
/>

        <Legend
          verticalAlign="bottom"
          align="center"
          wrapperStyle={{
            marginTop: 10,
            paddingTop: 0,
            marginBottom: -80,
          }}
        />
        <Bar
          dataKey="withParticipante"
          name="Con Participante"
          fill={COLORS.withParticipante}
          stackId="a"
          cursor="pointer"
          onClick={handleBarClick}
        />
        <Bar
          dataKey="withOrganizacion"
          name="Con Organización"
          fill={COLORS.withOrganizacion}
          stackId="a"
          cursor="pointer"
          onClick={handleBarClick}
        />
        <Bar
          dataKey="sinRegistro"
          name="Sin Registro"
          fill={COLORS.sinRegistro}
          stackId="a"
          cursor="pointer"
          onClick={handleBarClick}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
